import {gql} from "@apollo/client";

export const FGM_BILLING_DATA_FIELDS = gql`
  fragment BillingDataFields on BillingData {
    cardholder_name
    company_name
    billing_name
    billing_email
    address_1
    address_2
    phone
    country
    city
    state
    zipcode
    additional_info
  }
`;
